export default {
  DJToJS: {
    /**
     * @typedef {Object} IterationDJ
     * @property {Number} id - Identifiant de l'itération
     * @property {number} number - Nombre de fois que l'utilisateur a passé le questionnaire
     * @property {Boolean} is_finished - Indique si l'itération est actuellement clôturée
     * @property {String} created_at - Date à laquelle l'itération a été crée
     * @property {String} updated_at - Date à laquelle l'itération a été modifiée
     * @property {String|null} finished_at - Date à laquelle l'itération a été clôturée
     * @property {Number} questionnaire - Identifiant du questionnaire lié à l'itération
     * @property {Number|null} position_page - Identifiant de la page où l'utilisateur s'est arrêté
     * @property {Number|null} position_question - Identifiant de la question où l'utilisateur s'est arrêté
     *
     * @param iteration {IterationDJ}
     * @return {IterationAir}
     */
    convertIteration (iteration) {
      return {
        id: iteration.id,
        number: iteration.number,
        isFinished: iteration.is_finished,
        createdAt: new Date(iteration.created_at),
        updatedAt: new Date(iteration.updated_at),
        finishedAt: !iteration.finished_at ? null : new Date(iteration.finished_at),
        // user: iteration.user,
        positionPage: iteration.position_page,
        positionQuestion: iteration.position_question
      }
    },
    /**
     * @typedef {Object} UserQuestionnaireDJ
     * @property {Number} id - Identifiant du questionnaire
     * @property {String} label - Label du questionnaire
     * @property {String} description - Description du questionnaire
     * @property {String} created_at - Date de création du questionnaire
     * @property {String} updated_at - Date de mise à jour du questionnaire
     * @property {String} publication_date - Date de publication du questionnaire
     * @property {array} pages - Tableau regroupant les pages liées au questionnaire
     * @property {Number} pages.id - Identifiant de la page
     * @property {Number} pages.number - Numéro de page
     * @property {Number} user - Identifiant de l'utilisateur propriétaire du questionnaire
     * @property {Boolean} is_published - Indique si le questionnaire est publié
     * @property {IterationDJ[]} iterations - Liste des itérations liées au questionnaire
     *
     * @param questionnaire {UserQuestionnaireDJ}
     * @return {UserQuestionnaireAir}
     */
    convertQuestionnaire (questionnaire) {
      return {
        id: questionnaire.id,
        label: questionnaire.label,
        description: questionnaire.description,
        createdAt: new Date(questionnaire.created_at),
        updatedAt: new Date(questionnaire.updated_at),
        publicationDate: new Date(questionnaire.publication_date),
        pages: !questionnaire.pages ? [] : questionnaire.pages,
        iterations: questionnaire.iterations.map(iteration => this.convertIteration(iteration)),
        user: questionnaire.user,
        isPublished: questionnaire.is_published
      }
    }
  },
  JSToDJ: {}
}
